import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter);

const routes = [
    {
        path: '/vue/',
        name: 'Home',
        meta: {title: "首页",},
        component: Home,
    }, {
        path: '/vue/search-map',
        name: 'SearchMap',
        meta: {title: "地名船位搜索",},
        component: () => import(/* webpackChunkName: "search-map" */ '../views/SearchMap.vue')
    }, {
        path: '/vue/search-map-redirect',
        name: 'SearchMapRedirect',
        meta: {title: "地名船位搜索",},
        component: () => import(/* webpackChunkName: "search-map-redirect" */ '../views/SearchMapRedirect.vue')
    }, {
        path: '/vue/preview-map',
        name: 'PreviewMap',
        meta: {title: "船位预览",},
        component: () => import(/* webpackChunkName: "preview-map" */ '../views/PreviewMap.vue')
    }, {
        path: '/vue/recent-vessels',
        name: 'RecentVessels',
        meta: {title: "最近联系船舶",},
        component: () => import(/* webpackChunkName: "recent-vessels" */ '../views/RecentVessels.vue')
    }, {
        path: '/vue/vessel-mmsi-review',
        name: 'VesselMmsiReview',
        meta: {title: "经纪人修改的MMSI",},
        component: () => import(/* webpackChunkName: "vessel-mmsi-review" */ '../views/VesselMmsiReview.vue')
    }, {
        path: '/vue/vessel-mmsi-deny',
        name: 'VesselMmsiDeny',
        meta: {title: "经纪人解绑的MMSI",},
        component: () => import(/* webpackChunkName: "vessel-mmsi-deny" */ '../views/VesselMmsiDeny.vue')
    }, {
        path: '/vue/vessel-history-route',
        name: 'VesselHistoryRoute',
        meta: {title: "历史航次",},
        component: () => import(/* webpackChunkName: "vessel-history-route" */ '../views/VesselHistoryRoute.vue')
    }, {
        path: '/vue/practice-exam-map',
        name: 'PracticeExamMap',
        meta: {title: "知识训练试题地图",},
        component: () => import(/* webpackChunkName: "practice-exam-map" */ '../views/PracticeExamMap.vue')
    }, {
        path: '/vue/practice-map',
        name: 'PracticeMap',
        meta: {title: "知识训练地图",},
        component: () => import(/* webpackChunkName: "practice-map" */ '../views/PracticeMap.vue')
    }, {
        path: '/vue/dock-list',
        name: 'DockList',
        meta: {title: "码头列表",},
        component: () => import(/* webpackChunkName: "dock-list" */ '../views/DockList.vue')
    }, {
        path: '/vue/wechat-landmark',
        name: 'WechatLandmark',
        meta: {title: "地标详情",},
        component: () => import(/* webpackChunkName: "wechat-landmark" */ '../views/WechatLandmark.vue')
    }, {
        path: '/vue/wechat-position',
        name: 'WechatPosition',
        meta: {title: "地标位置",},
        component: () => import(/* webpackChunkName: "wechat-position" */ '../views/WechatPosition.vue')
    }, {
        path: '/vue/loading-vessel-map',
        name: 'LoadingVesselMap',
        meta: {title: "船货不二-承运船舶",},
        component: () => import(/* webpackChunkName: "loading-vessel-map" */ '../views/LoadingVesselMap.vue')
    },
];

const router = new VueRouter({
    mode: 'history',
    routes,
});

router.beforeEach((to, from, next) => {
    document.title = to.meta.title || "内撮系统";
    next();
});

export default router;
